import { Controller } from "@hotwired/stimulus";

// Instruments the "Connect a payout account to collect" CTA on the referral
// dashboard (referrals/show.html.haml) — shown only once collectable cash
// clears ReferralCommission::MIN_PAYOUT_PROMPT_CENTS. Pairs with
// payout_onboarding_started/payout_onboarding_completed (server-side, tagged
// source=referral_banner) to answer the full shown -> clicked -> connected
// funnel.
export default class extends Controller {
  static values = {
    amountCents: Number,
  };

  connect() {
    this.trackEvent("referral_payout_prompt_shown");
  }

  click() {
    this.trackEvent("referral_payout_prompt_clicked");
  }

  trackEvent(eventName) {
    if (typeof window.posthog !== "undefined") {
      window.posthog.capture(eventName, {
        collectable_cents: this.amountCentsValue,
      });
    }
  }
}
